<template>
	<lcsj-dialog v-model="showDialog" ref="editForm" title="出库单详情" width="80%" @close="closeDialog" cancel-text="关闭"
		:confirm-text="canRollback ? '回退出库' : ''" :confirm-loading="isSubmitting" @confirm="rollbackOutputStore">
		<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
			<div class="item_info border_Warningcolor">
				<el-descriptions class="margin-top" title="基本信息" :column="3" border>
					<el-descriptions-item label="出库单号">{{ editForm.outputStoreNo }}</el-descriptions-item>
					<el-descriptions-item label="出库时间">{{ editForm.outputDate }}</el-descriptions-item>

					<el-descriptions-item label="所属门店">{{ editForm.belongStoreName }}</el-descriptions-item>
					<el-descriptions-item label="顾客姓名">{{ transformEmpty(customerInfo.name) }}</el-descriptions-item>
					<el-descriptions-item label="性别">{{ transformGender(customerInfo.gender) }}</el-descriptions-item>
					<el-descriptions-item label="年龄">{{ transformEmpty(customerInfo.age) }}</el-descriptions-item>
					<el-descriptions-item label="顾客电话">{{ transformEmpty(customerInfo.phone) }}</el-descriptions-item>
					<el-descriptions-item label="下单日期">{{ transformEmpty(editForm.orderDate) }}</el-descriptions-item>

					<el-descriptions-item label="取镜日期">{{ transformEmpty(editForm.getOrderDate) }}</el-descriptions-item>

					<el-descriptions-item label="验光师">{{ transformEmpty(editForm.yanGuangShi) }}</el-descriptions-item>

					<el-descriptions-item label="加工类型">{{ transformEmpty(editForm.machinTypeStr) }}</el-descriptions-item>
					<el-descriptions-item label="出库状态">{{ editForm.outputStateStr }}</el-descriptions-item>

					<el-descriptions-item label="镜架信息" span="3">{{ transformEmpty(editForm.jjInformation) }}</el-descriptions-item>
					<el-descriptions-item label="备注" span="3">{{ transformEmpty(editForm.remark) }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">商品信息</div>
				</div>
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="goodsTableData" style="width: 100%" border :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center', borderColor: 'var(--app-table-border)' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="type" label="商品品牌" width="120"></el-table-column>
					<el-table-column prop="name" label="商品名称"></el-table-column>
					<el-table-column prop="qiuJing" label="球镜" width="80"></el-table-column>
					<el-table-column prop="zhuJing" label="柱镜" width="80"></el-table-column>
					<el-table-column prop="unit" label="单位" width="80"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="price" label="单价" width="100"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="155"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="money" label="金额" width="100"></el-table-column>
					<el-table-column prop="remark" label="ADD"></el-table-column>
				</el-table>
			</div>
		</div>
		
	</lcsj-dialog>
</template>
<script>
import costPermission from "@/utils/costPermission.js";
import { GetOutputStoreDetail, RollbackOutputStore } from "@/api/receiptApi.js";

export default {
	mixins: [costPermission],
	props: [],
	data() {
		return {
			showDialog: false,
			detailLoaded: false,
			isSubmitting: false,
			loadRequestId: 0,
			rollbackPermission: false,
			saveloading: false,
			loading: false,
			editForm: {},
			goodsKeyIds: [],
			supplyList: [],
			customerInfo: {},
			goodsTableData: [],
			goodsIndex: 1

		};
	},
	computed: {
		canRollback() {
			return this.showDialog && this.detailLoaded && !this.loading && this.rollbackPermission && !!this.editForm.keyId && Number(this.editForm.outputState) !== 3;
		}
	},
	watch: {},
	components: {},
	created() {},
	methods: {
		hasRollbackPermission() {
			return this.$checkBtnPermission("/outputStore/index", "rollbackOutputStore");
		},
		async rollbackOutputStore() {
			if (!this.canRollback || this.isSubmitting || !this.hasRollbackPermission()) return;
			const { keyId, outputStoreNo } = this.editForm;
			const requestId = this.loadRequestId;
			this.isSubmitting = true;
			try {
				try {
					await this.$confirm("确定回退出库单【" + outputStoreNo + "】吗？该单商品将退回库存，订单状态保持不变。", "回退出库", {
						confirmButtonText: "确认回退", cancelButtonText: "取消", type: "warning"
					});
				} catch (_) { return; }
				if (!this.canRollback || this.editForm.keyId !== keyId || this.loadRequestId !== requestId || !this.hasRollbackPermission()) return;
				const res = await RollbackOutputStore({ keyId });
				if (res.code === 1) {
					this.$message({ type: "success", message: res.msg || "出库单已回退，商品已退回库存。" });
					if (this.loadRequestId === requestId) {
						this.detailLoaded = false;
						this.showDialog = false;
					}
					if (this.$parent && this.$parent.getListData) this.$parent.getListData();
				} else {
					this.$message({ type: "error", message: res.msg || "回退失败，请重试。" });
				}
			} catch (_) {
				this.$message.error("回退结果未确认，请重试；重复操作不会重复返还库存。");
			} finally { this.isSubmitting = false; }
		},
		// 显示
		showDetailDialog(keyId) {
			this.rollbackPermission = this.hasRollbackPermission();
			this.editForm.keyId = keyId;
			this.showDialog = true;
			this.GetOutputStoreDetail();
		},
		// 获取入库单详情
		GetOutputStoreDetail() {
			const requestId = ++this.loadRequestId;
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			this.saveloading = true;
			const params = {
				keyId: this.editForm.keyId
			};
			return GetOutputStoreDetail(params)
				.then((res) => {
					if (requestId !== this.loadRequestId || !this.showDialog) return;
					this.saveloading = false;
					if (res.code == 1 && res.data && res.data.keyId === params.keyId) {
						this.editForm = res.data;
						this.detailLoaded = true;
						this.customerInfo = res.data.customerInfo;
						if (res.data.dtls != null && res.data.dtls.length > 0) {
							let rowNumber = 1;
							res.data.dtls.forEach((item) => {
								var info = {};
								info.rowNumber = rowNumber++;
								info.name = item.goodsInfo.name;
								info.type = item.goodsInfo.type;
								info.unit = item.goodsInfo.unit;
								info.qiuJing = item.goodsInfo.qiuJing;
								info.zhuJing = item.goodsInfo.zhuJing;
								info.goodsKeyId = item.goodsInfo.keyId;
								info.remark = item.remark;
								info.quantity = item.quantity;
								info.money = item.money;
								info.price = item.price;
								this.goodsTableData.push(info);
							});
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					if (requestId !== this.loadRequestId || !this.showDialog) return;
					this.detailLoaded = false;
					this.saveloading = false;
					this.$message.error("生成失败，请稍后再试！");
				})
				.finally(() => {
					if (requestId === this.loadRequestId) this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.detailLoaded = false;
			const keyId = this.editForm.keyId;
			this.editForm = { keyId: keyId };
			this.customerInfo = {};
			this.goodsTableData = [];
			this.goodsKeyIds = [];
			this.goodsIndex = 1;
		},
		// 关闭
		closeDialog() {
			this.loadRequestId++;
			this.detailLoaded = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
			this.goodsKeyIds = [];
			this.goodsIndex = 1;
			this.goodsTableData = [];
			this.showDialog = false;
		},
		// 性别
		transformGender(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}
}
</style>
